module.exports = __webpack_public_path__ + "static/media/pasta_amphora.705977d9.png";